import { createProvider } from '@nvision/services/data-provider';

import type { CurrencyFilters } from '../../models';
import * as api from './api';
import { normalizeCurrencies, normalizeCurrencyFilters } from './normalize';

export const fetchCurrencies = createProvider(
  (filters: Partial<CurrencyFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchCurrencies(normalizeCurrencyFilters(filters), { signal }),
).andThen((res) => normalizeCurrencies(res));
